// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"57cba883","500":"c96230ae","952":"16e5d612"}[chunkId] + ".chunk.js";
};